import React from "react";
import { FiClock, FiUserCheck } from "react-icons/fi";
import { HomeOverviewCard } from "./HomeOverviewCard";
import taskPendingIllustration from "../../img/task-pending-illustration.png";

export function HomeTasksPending({ count = 0 }) {
  return (
    <HomeOverviewCard
      count={count}
      countLabel="Tasks Pending"
      description="View all tasks that are assigned to you and pending."
      Icon={FiUserCheck}
      illustration={taskPendingIllustration}
      title="Tasks Pending Me"
      to="/tasks/reports/pending-me"
      tone="green"
      VisualIcon={FiClock}
    />
  );
}
